import { InteractiveTable } from './InteractiveTable'
import { Search } from './Search'

export const HeaderFollowingList = () => {
  return (
    <>
      <Search />
      <InteractiveTable />
    </>
  )
}
